export class LocalStorageKeys {
	public static readonly lastSyncKey = "lastSync";
	public static readonly clientIdKey = "clientId";
}
export function RemoveLastSynced() {
	localStorage.removeItem(LocalStorageKeys.lastSyncKey);
	localStorage.removeItem(LocalStorageKeys.clientIdKey);
}
